export interface TranslatedData {
  clientId: string;
  entityId: string;
  clientTaxPeriodId: number;
  state: string;
  reconCode: string;
  tax: number;
  grossSales: number;
  taxableSales: number;
  nonTaxableSales: number;
  taxableFreight: number;
  nonTaxableFreight: number;
  taxablePurchases: number;
  taxAccrual: number;
}
